import { IonContent, IonNavLink, IonPage, IonText } from '@ionic/react'
import moment from 'moment-timezone'
import React from 'react'
import styled from 'styled-components'
import { ResultTradeProduct, ResProductDetail } from '../../../../common'
import { CustomSpacer, FooterButtons, StyleIonHeader, TextStyle } from '../../../../components'
import { DivideLineBold, DivideLine } from '../../../../components/atoms/divide'
import { TradeResultCancelModal } from './TradeResultCancelModal'

type Props = {
  tradeResult: ResultTradeProduct
  productData: ResProductDetail
  onDismiss: () => void
}

export const TradeResultYetModal: React.FC<Props> = ({ tradeResult, productData, onDismiss }) => {
  return (
    <IonPage>
      <StyleIonHeader type={'MODAL'} title={'주문이 미체결되었습니다.'} onDismiss={onDismiss} />
      <IonContent>
        <ProductContainer>
          <ProductInfoContainer>
            <img
              src={productData.imageUri}
              alt={productData.name}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = '/img/thumbnail.svg'
              }}
            />
            <div className="product-info">
              <IonText className="artist">{productData.artist}</IonText>
              <IonText className="title">{productData.name}</IonText>
            </div>
          </ProductInfoContainer>
        </ProductContainer>
        <DivideLineBold />
        <SectionContainer>
          <TextStyle type={'b_16'}>결제정보</TextStyle>
          <CustomSpacer spacing="16px" />
          <BetweenWrap>
            <TextStyle type={'r_13'}>주문번호</TextStyle>
            <TextStyle type={'b_15'}>{tradeResult.tradeOrder.orderSequence}</TextStyle>
          </BetweenWrap>
          <BetweenWrap>
            <TextStyle type={'r_13'}>주문일시</TextStyle>
            <TextStyle type={'b_15'}>{`${moment(new Date(tradeResult.tradeOrder.createdDate)).format(
              'YYYY.MM.DD HH:MM:SS',
            )}`}</TextStyle>
          </BetweenWrap>
        </SectionContainer>
        <DivideLineBold />
        <SectionContainer>
          <TextStyle type={'b_16'}>{`최종 ${
            tradeResult.tradeOrder.type === 'BUY' ? '구매' : '판매'
          } 예정 금액`}</TextStyle>
          <CustomSpacer spacing="16px" />
          <BetweenWrap>
            <TextStyle type={'r_13'}>{tradeResult.tradeOrder.type === 'BUY' ? '구매 수량' : '판매 수량'}</TextStyle>
            <TextStyle type={'b_15'}>{tradeResult.tradeOrder.count.toLocaleString()} 개</TextStyle>
          </BetweenWrap>
          <BetweenWrap2>
            <TextStyle type={'r_13'}>단가</TextStyle>
            <TextStyle type={'b_15'}>{tradeResult.tradeOrder.cost.toLocaleString('ko-kr')} 원</TextStyle>
          </BetweenWrap2>
          <DivideWrap>
            <DivideLine />
          </DivideWrap>
          <BetweenWrap>
            <TextStyle type={'b_16'}>{`${
              tradeResult.tradeOrder.type === 'BUY' ? '구매' : '판매'
            } 예정 금액(수수료 1.1% 포함)`}</TextStyle>
            <TextStyle type={'b_16'}>{`${Math.floor(
              tradeResult.tradeOrder.cost * tradeResult.tradeOrder.count * 1.011,
            ).toLocaleString('ko-Kr')} 원`}</TextStyle>
          </BetweenWrap>
        </SectionContainer>
      </IonContent>
      <IonNavLink
        routerDirection="forward"
        component={() => (
          <TradeResultCancelModal tradeResult={tradeResult} productData={productData} onDismiss={onDismiss} />
        )}
      >
        {tradeResult.tradeOrder.type === 'BUY' ? (
          <FooterButtons button={{ color: 'primary', text: '미체결 주문을 취소하시겠습니까?' }} />
        ) : (
          <FooterButtons button={{ color: 'danger', text: '미체결 주문을 취소하시겠습니까?' }} />
        )}
      </IonNavLink>
    </IonPage>
  )
}

const ProductContainer = styled.div`
  padding: 24px 20px;
`

const ProductInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  img {
    border-radius: 7px;
    min-width: 80px;
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
  }
  .product-info {
    grid-area: 1 / 1 / 2 / 5;
    display: flex;
    flex-direction: column;
    font-size: 15px;
    .artist {
      white-space: nowrap;
      color: var(--ion-color-primary_light);
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      font-size: 16px;
      font-weight: 700;
    }
  }
`

const SectionContainer = styled.div`
  padding: 24px 20px;
`
const BetweenWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

const BetweenWrap2 = styled.div`
  display: flex;
  justify-content: space-between;
`

const DivideWrap = styled.div`
  padding: 16px 0;
`
